import { gql, FieldReadFunction } from '@apollo/client';

import { getInLocalStorage, constants } from '@trqk/utils';

export const GET_ENVIRONMENT = gql`
    query getEnvironment {
        environment @client
    }
`;

const readEnvironment: FieldReadFunction<Environment> = () =>
    getInLocalStorage(constants.LOCAL_STORAGE_KEYS.ENVIRONMENT) ??
    ('development' as Environment);

export const environment = {
    read: readEnvironment,
};
